import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetJournal, setMatchesByTournament } from "../../../../../redux/actions/matches";

export const useFetchMatches = ({hasIdFromParams = false, id})=>{
    const tournaments = useSelector(state => state?.tournaments?.tournaments);
    const matches = useSelector(state => state?.matches?.matchesByTournament);
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    const [labelJournals, setLabelJournals] = useState({'Todas': true});
    const [labelGroups, setLabelsGroups] = useState({'Todos': true})

    const dispatch = useDispatch();
const sortByJournal = (a, b) => {
    const priorities = [
        "final de vuelta",
        "final de ida",
        "final",
        "semifinales de vuelta",
        "semifinales de ida",
        "semifinal",
        "cuartos de final vuelta",
        "cuartos de final ida",
        "cuartos de final",
        "octavos de final vuelta",
        "octavos de final ida",
        "octavos de final",
        "dieciseisavos de final vuelta",
        "dieciseisavos de final ida",
        "dieciseisavos de final",
    ];

    const normalize = (text) => text?.toLowerCase()?.trim() ?? '';

    const getPriority = (item) => {
        const jornada = normalize(item.jornada);

        const index = priorities.findIndex(p => jornada === p);
        if (index !== -1) return 1000 - index; // High number = high priority

        const num = parseInt(jornada.split(' ')?.[1]);
        return isNaN(num) ? -1 : num; // Lower if unrecognized
    };

    return getPriority(b) - getPriority(a); // Descending order
};

    useEffect(()=>{
        if(!selectedTournament) return;
        const urlToFetchMatchesByTournament = 'https://web-production-58ed.up.railway.app/api/user/get/all/jorndas/bytorneo';
        const idTournament =  hasIdFromParams ? id :selectedTournament?._id;

        const fetchMatchesByTournament = async ()=>{
            try {
                setLabelJournals({'Todas':true})
                dispatch(resetJournal());
                const matchesByTournament = await  axios.post(urlToFetchMatchesByTournament,{torneo: idTournament})
                const matchesSort = matchesByTournament?.data?.TotalJornadas.sort(sortByJournal)
                 matchesSort.forEach(match => {
                    
                        setLabelJournals(prev => ({...prev, [match?.jornada] : true}))
                        
                    if(!labelGroups[match?.equipoLocal?.grupo]){
                        setLabelsGroups(prev => ({...prev, [match?.equipoLocal?.grupo]: true}))
                    }
                });
                dispatch(setMatchesByTournament(matchesSort))
            } catch (error) {
                
            }

        }
        fetchMatchesByTournament();

    },[selectedTournament])

    return{
        matches,
        selectedTournament, 
        tournaments,
        labelJournals,
        labelGroups       
    }

}